import Button from 'components/atoms/Button';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import classNames from 'classnames';
import './styles.scss';
import tipoDocEnum from 'pools/tipoDocEnum';

const Menu = () => {
  const { user, setUser } = useContext(GlobalContext);
  const history = useHistory();
  const [showDocumentsMenu, setShowDocumentsMenu] = useState(false);

  const documentsMenuClass = classNames({
    documents__menu: true,
    'documents__menu--visible': showDocumentsMenu,
  });

  // When logout, remove user from session storage, clean up user Context and push user to login page
  function onLogout() {
    setUser({ isAuthenticated: false, token: '' });
    sessionStorage.removeItem('user');
    history.push('/login');
  }

  return (
    <nav className="menu">
      <input className="ham__check" type="checkbox" id="ham" />
      {/* Hambuguer menu */}
      <label htmlFor="ham" className="ham__label">
        <div className="ham__line"></div>
        <div className="ham__line"></div>
        <div className="ham__line"></div>
      </label>
      <div className="menu__items">
        <Button visual="home" tag="a" href="//www.sabesp.com.br" target="_self">
          Voltar ao Site Sabesp
        </Button>
        {!user.isAuthenticated && (
          <Button visual="admin" tag={Link} to="/login">
            Entrar
          </Button>
        )}
        {user.isAuthenticated && (
          <>
            <div className="menu__add" onBlur={() => setShowDocumentsMenu(false)}>
              <Button visual="add" onClick={() => setShowDocumentsMenu((prevState) => !prevState)}>
                Adicionar Nova
              </Button>
              <div className={documentsMenuClass}>
                <Button tag={Link} to={`/Novo/${tipoDocEnum[1]}`} visual="new">
                  Norma Técnica
                </Button>
                <Button tag={Link} to={`/Novo/${tipoDocEnum[2]}`} visual="new">
                  Desenho Padrão
                </Button>
              </div>
            </div>
            <Button visual="logout" onClick={onLogout} title="Sair" />
          </>
        )}
      </div>
    </nav>
  );
};

export default Menu;
